import request from '@/libs/request'

export function articleList (data) {
  return request({
    url: `news/list`,
    method: 'get',
    params: data
  })
}

// 公告详情
export function articleInfo (data) {
  return request({
    url: `news/info`,
    method: 'get',
    params: data
  })
}

// 添加公告
export function eidtArticle (data) {
  return request({
    url: `news/edit`,
    method: 'post',
    data: data
  })
}

// 删除公告
export function delNew (id) {
  let data = { article_id: id }
  return request({
    url: `news/delete`,
    method: 'post',
    data: data
  })
}

export function changeSort (params) {
  return request({
    url: `news/changeSort`,
    method: 'get',
    params
  })
}
// 启用禁用
export function changeStatus (id) {
  return request({
    url: `news/changeStatus/${id}`,
    method: 'post'
  })
}
export function getIndexCate (params) {
  return request({
    url: `news/getIndexCate`,
    method: 'get',
    params
  })
}
//分类列表
export function cateList (data) {
  return request({
    url: `newsCate/lists`,
    method: 'get',
    params: data
  })
}
